type Task = "fonts" | "load" | "water";
export const FILL_MS = 2000;
const EMPTY_Y = 70;
const FULL_Y = 12;
const lineAt = (level: number): string =>
  `translateY(${EMPTY_Y - (EMPTY_Y - FULL_Y) * (Math.min(100, Math.max(0, level)) / 100)}px)`;
const FADE = 14;
const lineOpacity = (level: number): number =>
  Math.max(0, Math.min(1, level / FADE, (100 - level) / FADE));
const WEIGHT: Record<Task | "page", number> = { page: 15, fonts: 25, load: 30, water: 30 };
const done = new Set<Task>();

export function loaderTask(task: Task): void {
  done.add(task);
}

const finishAt = () => WEIGHT.page + [...done].reduce((sum, t) => sum + WEIGHT[t], 0);
export const loaderProgress = (): number => finishAt();

export function runLoader(): Promise<void> {
  const root = document.documentElement;
  const el = document.querySelector<HTMLElement>("[data-loader]");
  const mark = el?.querySelector<HTMLElement>("[data-loader-mark]");
  const count = el?.querySelector<HTMLElement>("[data-loader-count]");
  const line = el?.querySelector<SVGGElement>("[data-loader-line]");
  void document.fonts?.ready.then(() => loaderTask("fonts"));
  if (document.readyState === "complete") loaderTask("load");
  else window.addEventListener("load", () => loaderTask("load"), { once: true });
  if (!el || !mark || !count || root.classList.contains("no-loader")) {
    el?.remove();
    return Promise.resolve();
  }
  root.classList.add("is-loading");
  const remember = () => {
    try {
      sessionStorage.setItem("otridon:loaded", "1");
    } catch {
    }
  };

  return new Promise((resolve) => {
    const started = performance.now();
    let level = 0;
    let last = started;
    const finish = () => {
      remember();
      el.classList.add("is-done");
      resolve();
      window.setTimeout(() => {
        el.remove();
        root.classList.remove("is-loading");
      }, 800);
    };
    const tick = (now: number) => {
      const dt = Math.min(0.1, (now - last) / 1000);
      last = now;
      const ready = now - started > 6000 ? 100 : finishAt();
      level = Math.min(ready, level + dt * 1000 * (100 / FILL_MS));
      const n = Math.round(level);
      count.textContent = String(n);
      if (line) {
        line.style.transform = lineAt(level);
        line.style.opacity = String(lineOpacity(level));
      }
      if (n >= 100) {
        window.setTimeout(finish, 450);
        return;
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  });
}
